import { memo, type ReactNode } from 'react';
import { ENTITY_MODAL_SECTIONS_GRID_CLASS } from './entityUnifiedModalStyles.js';

export interface EntityUnifiedTabSectionsProps {
  readonly children: ReactNode;
  readonly className?: string;
  /** Override default auto-fit grid (e.g. {@link ENTITY_MODAL_SECTIONS_GRID_FOUR_CLASS}). */
  readonly sectionsGridClass?: string;
  readonly testId?: string;
}

/**
 * Multi-section entity modal tab layout — 1 → 2 → 3 columns via auto-fit at
 * `@container/entity-modal` width (not viewport). Use inside EntityUnifiedModal tab body.
 */
export const EntityUnifiedTabSections = memo<EntityUnifiedTabSectionsProps>(({
  children,
  className,
  sectionsGridClass = ENTITY_MODAL_SECTIONS_GRID_CLASS,
  testId,
}) => (
  <div
    className={[sectionsGridClass, className].filter(Boolean).join(' ')}
    data-testid={testId}
  >
    {children}
  </div>
));

EntityUnifiedTabSections.displayName = 'EntityUnifiedTabSections';
